import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LeadershipTopConversationThemesLoadAction } from '../../domains/leadershipTopConversationThemes/actions.types';

import { LeadershipTopConversationThemes } from './types';
export const initialState: LeadershipTopConversationThemes = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<LeadershipTopConversationThemes, LeadershipTopConversationThemesLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'LEADERSHIP_TOP_CONVERSATION_THEMES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.leadershipTopConversationThemes);
    default:
      return state;
  }
};

export default reducer;
